/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon16Solid = forwardRef('ArrowDCornerLeftDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9 3.25a.75.75 0 0 0-.75.75v7.232l2.366-2.366a1.25 1.25 0 0 1 1.768 1.768l-3.652 3.651a2.45 2.45 0 0 1-3.464 0l-3.652-3.651a1.25 1.25 0 0 1 1.768-1.768l2.366 2.366V4A3.25 3.25 0 0 1 9 .75h5.75a1.25 1.25 0 1 1 0 2.5H9Z" })));
});
